import GNBTab from '@/components/@IntranetLibrary/GNB/GNBTab';
import { GNBWrapper, LogoLink } from '@/components/@IntranetLibrary/GNB/styles';
import LogoImage from '@/public/images/logo_fnf.svg';
import { Stack } from '@mui/material';
import GNBMenu from '@/components/@IntranetLibrary/GNB/GNBMenu';
import React, { Suspense } from 'react';
import Alarm, { AlarmSuspense } from '@/components/Alarm';
import GNBProfile from 'components/@IntranetLibrary/GNB/GNBProfile';
import { GNBEventName } from '@/constant/gtm';
import { PAGE_URL } from '@/constant/url';
import { useGNBEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { GNBZIndex } from '@/constant/z-index';
import { useGNBTabs } from '@/hooks/main/useGNBTabs';
import { useRouter } from 'next/router';

export type GNBProps = {
  isShowTabs?: boolean;
};

const GNB = ({ isShowTabs = false }: GNBProps) => {
  const router = useRouter();
  const tabProps = isShowTabs ? useGNBTabs() : {};
  const gnbEventTracker = useGNBEventTracker();

  // 로고 클릭 핸들러
  const handleClickLogo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    gnbEventTracker(GNBEventName.clickHome);

    // 1. 현재 내가 'Home' 탭에 있는지 확인합니다.
    // 쿼리가 없으면 홈(기본값)으로 간주하거나, tab=home인 경우를 체크
    const currentTab = router.query.tab;
    const isAtHome =
      router.pathname === '/' && (!currentTab || currentTab === 'home');

    if (isAtHome) {
      // ✅ Case A: 이미 홈에 있다면 -> "강제 새로고침" (상태 초기화 목적)
      window.location.href = PAGE_URL.HOME;
    } else {
      // ✅ Case B: 다른 탭(Work, Social)에 있다면 -> "Next.js 라우팅" (성능 최적화)
      router.push(PAGE_URL.HOME);
    }
  };

  return (
    <GNBWrapper sx={{ zIndex: GNBZIndex }}>
      <GNBTab {...tabProps} />
      <LogoLink id={'FnF-logo'} href={PAGE_URL.HOME} onClick={handleClickLogo}>
        <LogoImage className={'fnf-logo'} />
      </LogoLink>
      <Stack direction={'row'} alignItems={'center'} gap={'20px'}>
        <GNBMenu />
        <Suspense fallback={<AlarmSuspense />}>
          <Alarm />
        </Suspense>
        <GNBProfile />
      </Stack>
    </GNBWrapper>
  );
};
export default GNB;
